import httpClient from '@/http-client'

export const get = (options = {}) => {
    return httpClient
        .get('/api/certificate-operation-prints', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
    return httpClient
        .post('/api/certificate-operation-prints', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
    return httpClient
        .put(`/api/certificate-operation-prints/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const approve = (options = {}) => {
    return httpClient
        .get('/api/certificate-operation-prints/approve', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
};

export const certificateOperationPrintApprove = (id, data) => {
    return httpClient
        .post(`/api/certificate-operation-prints/certificate-operation-print-approve/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
    return httpClient
        .delete(`/api/certificate-operation-prints/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const reachCandidate = (id, data) => {
    return httpClient
        .post(`/api/certificate-operation-prints/reach-candidate/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const formModel = (options = {}) => {
    return httpClient
        .get('/api/certificate-operation-prints/form-view-models', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const printPdf = (Options = {}) => {
    return httpClient
      .get('/api/certificate-operation-prints/print-pdf', Options)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
  }

export default { get, store, update, destroy, formModel, approve, certificateOperationPrintApprove, reachCandidate, printPdf }